<template>
  <div :class="{'modal':true, 'is-active':show}">

    <div class="modal-background" @click="$emit('close-modal')"></div>
    <div class="modal-card">
        <header class="modal-card-head back-gradient-animation">
          <p class="modal-card-title has-text-centered">{{title}}</p>
          <button class="delete" aria-label="close" @click="$emit('close-modal')"></button>
        </header>
        <section class="modal-card-body">

    <div class="columns is-vcentered">
        <div class="column">
            <h4 class="title is-5 has-text-dark">Créditos</h4>
            <p class="subtitle is-6 has-text-grey-dark">{{numberFormat(currentCredits)}}</p>
        </div>
        <div class="column is-1">
            <fa :icon="'angle-double-'+(type>2?'left':'right')" class="fa-2x"/>
        </div>
        <div class="column">
            <h4 class="title is-5 has-text-dark">Zen</h4>
            <p class="subtitle is-6 has-text-grey-dark">{{numberFormat(currentZen)}}</p>
        </div>
    </div>

        <hr>

        <div class="field has-text-left">
            <label class="label">Selecciona la cantidad que deseas adquirir:</label>
            <div class="control">

            <div class="select" v-if="type>2">
                <select v-model="form.mount" v-validate="'required|numeric|min_value:1'" name="cantidad">
                    <option v-for="(c,n) in select.credits" :value="c" :key="n">{{c}} Créditos</option>
                </select>
            </div>
            <div class="select" v-else>
                <select v-model="form.mount" v-validate="'required|numeric|min_value:1'" name="cantidad">
                    <option v-for="(c,n) in select.zen" :value="c" :key="n">{{numberFormat(c)}} Zen</option>
                </select>
            </div>

            </div>
            <p class="help is-danger has-text-justified" v-if="errors.has('cantidad')">{{ errors.first('cantidad') }}</p>
        </div>

        <hr>

        <p>{{numberFormat(form.mount)}} <span v-if="type>2">Créditos</span><span v-else>Zen</span> = {{type>2?(numberFormat(form.mount*costs.zenToCredits)):(numberFormat(form.mount/costs.zenToCredits))}} <span v-if="type>2">Zen</span><span v-else>Créditos</span></p>

        </section>
        <footer class="modal-card-foot">
          <div class="buttons has-addons is-right">
            <button class="button" @click="$emit('close-modal')" type="button">Cancelar</button>
            <button :class="{'button is-link':true, 'is-loading':loading,}" 
            @click="verifyBeforeSubmit()" type="button">
                Convertir
            </button>
          </div>
        </footer>
    </div>

  </div>
</template>

<script>
export default {
    name:'WebBankInOutModal',
    props: {
        show: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: false
        },
        title: {
            type:String,
            default: ''
        },
        currentZen: {
            type:Number,
            default:0
        },
        currentCredits: {
            type:Number,
            default:0
        },
        type: {
            default: 0,
            type:Number
        }
    },
    data:()=>({
        form: {
            mount:0
        },
        select:{
            credits: [1,2,5,10,20,50,100,200,500,1000],
            zen: [
                1000000,
                2000000,
                5000000,
                10000000,
                20000000,
                50000000,
                100000000,
                200000000,
                500000000,
                1000000000
            ]
        }
    }),
    computed: {
      numberFormat() {
        return this.$store.getters.numberWithCommas
      },
      costs() {
          return this.$store.getters.costs
      }
    },
    methods: {
        verifyBeforeSubmit() {
            this.$emit('loading-run')
            this.$validator.validateAll().then(isValid => {
                if (!isValid) {
                    this.$emit('loading-stop')
                    return;
                }
                
                var message = ''
                if(this.type > 2) {
                    //console.log(this.form.mount*this.costs.zenToCredits,this.currentZen)
                    if ((this.form.mount*this.costs.zenToCredits) > this.currentZen) {
                        message = `No tienes suficiente Zen en tu banco para convertir a esa cantidad de Créditos.`
                        this.$toasted.show(message, { 
                            theme: 'toasted-danger', 
                            position: "top-center", 
                            duration : 5000
                        });
                        this.$emit('loading-stop')
                        return
                    }
                } else {
                    //console.log(this.form.mount/this.costs.zenToCredits,this.currentZen)
                    if ((this.form.mount/this.costs.zenToCredits) > this.currentCredits) {
                        message = `No tienes suficientes Créditos en tu banco para convertir a esa cantidad de Zen.`
                        this.$toasted.show(message, { 
                            theme: 'toasted-danger', 
                            position: "top-center", 
                            duration : 5000
                        });
                        this.$emit('loading-stop')
                        return
                    }
                }

                this.$emit('form-submit', this.form)
            })
        }
    }
}
</script>

<style scoped>
    .buttons {
        width: 100%;
    }
</style>